import * as models from 'src/models';
import * as types from 'src/localization/types';

export const localized: types.Localization<Record<models.locale.types.Locale, string>> = (env) => ({
  en: env.localizer('models.locale.en'),
  ja: env.localizer('models.locale.ja')
});
